import { Injectable } from "@angular/core";
declare let gtag: Function;

@Injectable({
  providedIn: "root",
})
export class GoogleAnalyticsService {
  constructor() {}
  public eventEmitter(
    eventName: string,
    eventCategory: string,
    eventAction: string,
    eventLabel: string = null,
    eventValue: number = null
  ) {
    gtag("event", eventName, {
      eventCategory: eventCategory,
      eventLabel: eventLabel,
      eventAction: eventAction,
      eventValue: eventValue,
    });
  }
  public tagEmitter(event: string, conversation: string, sendTo: string) {
    // Event snippet for כניסה לאתר conversion page

    gtag(event, conversation, {
      send_to: sendTo,
    });
  }
  //    Event snippet for יצירת קשר conversion page
  // In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button.

  gtag_report_conversion(url,sendTo) {
    var callback = function () {
      // if (typeof url != "undefined") {
      //   window.location = url;
      // }
    };
    gtag("event", "conversion", {
      send_to: sendTo,
      event_callback: callback,
    });
    return false;
  }
}
